import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const ControlFeature = ({ refs }) => {
    const mobile = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.control.description.1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.control.description.2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.control.description.3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.groups}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.control.tag'}
                id={'section-control'}
                img={`/static/asset/img/features/control_proces_predare.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-control-section'}
                title={'page.home.feature.control.description'}
                explanations={mobile}
            />
        </>
    );
};

export default ControlFeature;
